<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h5 class="my-6">Wypełnij formularz aby zmienić hasło do swojego konta</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          label="Aktualne hasło"
          v-model="current_password"
          class="w-100 mt-4"
          type="password"
        />
        <field-error :errorsBag="formErrors" fieldName="current_password" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          label="Nowe hasło"
          v-model="new_password"
          class="w-100 mt-4"
          type="password"
        />
        <field-error :errorsBag="formErrors" fieldName="new_password" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-input
          label="Powtórz hasło"
          v-model="password_confirmation"
          class="w-100 mt-4"
          type="password"
        />
        <field-error :errorsBag="formErrors" fieldName="password_confirmation" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vs-button type="filled round" icon-pack="feather" icon="icon-lock" class="mt-4">Zmień hasło</vs-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FieldError from "@/components/wod/forms/FieldError";

export default {
  name:'ChangePassword',
  components: { FieldError},
  data () {
      return {
        current_password: null,
        new_password: null,
        password_confirmation: null,
        formErrors: {},
      }
  },
}
</script>

<style>

</style>
